module.exports = __webpack_public_path__ + "static/media/laura.b4a99d01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotos/laura.png
// module id = 342
// module chunks = 0